import { Injectable } from "@angular/core";
import { isArray, isString } from "radash";
import { Customer } from "src/app/backend/models/customer/customer";

export enum DevxLoadOptionsFilterOperation {
  NOT = "!",
  EQUALS = "=",
  NOT_EQUALS = "!=",
  GREATER_THAN = ">",
  GREATER_THAN_OR_EQUAL_TO = ">=",
  LESS_THAN = "<",
  LESS_THAN_OR_EQUAL_TO = "<="
}

export interface DevxLoadOptionsFilter<
  T extends string | number | symbol = any
> {
  field: T;
  operation: DevxLoadOptionsFilterOperation;
  value: string;
  not: boolean;
}

export type DevxLoadOptionsFilterResult<
  T extends string | number | symbol = any
> = {
  [key in T]?: {
    not?: DevxLoadOptionsFilter[];
    and?: DevxLoadOptionsFilter[];
  };
};

@Injectable()
export class DevxService {
  parseForResult<T extends string | number | symbol = any>(
    loadOptionsFilter: any[]
  ): DevxLoadOptionsFilterResult<T> {
    const result = this.parseLoadOptionsFilter<T>(loadOptionsFilter);

    const ret: DevxLoadOptionsFilterResult<T> = {};

    result.forEach(
      ({
        value,
        field,
        not,
        operation
      }: {
        value: string;
        field: T;
        not: boolean;
        operation: DevxLoadOptionsFilterOperation;
      }) => {
        if (!ret[field]) {
          ret[field] = {};
        }

        if (not && ret[field]) {
          ret[field].not = [
            ...(ret[field].not || []),
            { value, field, not, operation }
          ];
        } else {
          ret[field].and = [
            ...(ret[field].and || []),
            { value, field, not, operation }
          ];
        }
      }
    );

    return ret;
  }

  parseLoadOptionsFilter<T extends string | number | symbol = any>(
    loadOptionsFilter: any[],
    filters: DevxLoadOptionsFilter[] = [],
    notMode: boolean = false
  ): DevxLoadOptionsFilter[] {
    for (const filterItem of loadOptionsFilter) {
      switch (true) {
        case isArray(filterItem): {
          this.parseLoadOptionsFilter(filterItem, filters, notMode);
          break;
        }
        case isString(filterItem): {
          switch (filterItem) {
            case "or":
            case "and": {
              break;
            }
            case "!": {
              notMode = !notMode;
              break;
            }
            default: {
              this.#parseFilter<T>(loadOptionsFilter, filters, notMode);
              return filters;
            }
          }
          break;
        }
      }
    }

    return filters;
  }

  #parseFilter<T extends string | number | symbol = any>(
    filter: any[],
    filters: DevxLoadOptionsFilter[],
    isNot: boolean
  ): void {
    const propertyKey = filter[0];
    const operation: DevxLoadOptionsFilterOperation = filter[1];
    const value: string = filter[2];

    filters.push({
      field: <T>propertyKey,
      operation,
      value,
      not: isNot
    });
  }
}
